import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=347eca6e&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports